module.exports = __webpack_public_path__ + "static/img/1.e8c5289.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.jpg
// module id = tGse
// module chunks = 21